import { translate } from "./localisation";

export const toLocaleDateString = (
  date,
  options = { year: "numeric", month: "short", day: "numeric" },
) => new Date(date).toLocaleDateString(translate("locale"), options);
